import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable, switchMap } from 'rxjs';

import { HttpService, PrintHtml, PrintService, UserPrinterDocument } from 'tms-lib';
import { UnBondStockItemsReport, UnBondStockReport } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CreateHtmlBondedStockInstructionService {
  private readonly httpService = inject(HttpService);
  private readonly printService = inject(PrintService);

  printTemplate(unBondStockReport: UnBondStockReport, unBondStockPrinter: UserPrinterDocument): Observable<any> {
    return forkJoin([
      this.httpService.getHtmlTemplate('templates/html-header.html'),
      this.httpService.getHtmlTemplate('templates/html-footer.html'),
      this.httpService.getHtmlTemplate('templates/un-bond-stock-header.html'),
      this.httpService.getHtmlTemplate('templates/un-bond-stock-item-header.html'),
      this.httpService.getHtmlTemplate('templates/un-bond-stock-item-footer.html'),
      this.httpService.getHtmlTemplate('templates/un-bond-stock-footer.html'),
    ]).pipe(
      switchMap(
        ([
          htmlHeaderTemplate,
          htmlFooterTemplate,
          headerTemplate,
          itemHeaderTemplate,
          itemFooterTemplate,
          footerTemplate,
        ]) => {
          const pages = this.printService.getPages(unBondStockReport.stockItems, 30, 2);

          const prints: PrintHtml[] = pages.map((page: UnBondStockItemsReport[], index: number) => {
            let html = htmlHeaderTemplate;
            html += this.printService.replaceTags(
              headerTemplate,
              this.printService.getPageModel(unBondStockReport, index, pages),
            );

            page.forEach((unBondStockItem: UnBondStockItemsReport) => {
              html += this.printService.replaceTags(itemHeaderTemplate, unBondStockItem);

              html += this.printService.replaceTags(itemFooterTemplate, unBondStockItem);
            });

            html +=
              index === page.length - 1
                ? this.printService.replaceTags(footerTemplate, unBondStockReport)
                : htmlFooterTemplate;

            return { html, printer: unBondStockPrinter };
          });
          return this.printService.printHtmls(prints);
        },
      ),
    );
  }
}
